<section class="wrapper">
  <section mat-dialog-title>
    <button mat-dialog-close mat-icon-button matTooltip="Close.">
      <mat-icon>close</mat-icon>
    </button>
    <h1>
      <mat-icon>star</mat-icon>
      {{ listingTitle }}
      @if (loading) {
        <mat-icon class="loading">autorenew</mat-icon>
      }
    </h1>
  </section>
  <section mat-dialog-content>
    <table mat-table [dataSource]="RelatedContent">
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef>Listing ID</th>
        <td mat-cell *matCellDef="let row">{{row.id }}</td>
      </ng-container>
      <ng-container matColumnDef="title">
        <th mat-header-cell *matHeaderCellDef>Listing Title</th>
        <td mat-cell *matCellDef="let row">{{row.title }}</td>
      </ng-container>
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef class="actions">
          <button (click)="addRelatedContent()" mat-icon-button matTooltip="Add related listing">
            <mat-icon>add</mat-icon>
          </button>
        </th>
        <td mat-cell *matCellDef="let row" class="actions">
          <button
            (click)="deleteRelatedContent(row)"
            mat-icon-button
            matTooltip="Delete Related Content"
            >
            <mat-icon>delete</mat-icon>
          </button>
        </td>
      </ng-container>
    </table>
    @if (PageEvent) {
      <mat-paginator
        (page)="DataSource.loadWithPageEvent($event)"
        [length]="PageEvent.length"
        [pageIndex]="PageEvent.pageIndex"
        [pageSize]="PageEvent.pageSize"
      ></mat-paginator>
    }
  </section>
</section>
